
  import Sticker from "@/components/sticker.vue";
  export default {
    name: "UnderConstruction",
    components: {
      Sticker,
    }
  };
